import React, { useState } from 'react';
import api from '../api';

export default function LoginPage({ onLogin }) {
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const [modus, setModus] = useState('login');
  const [fehler, setFehler] = useState('');

  async function submit(e) {
    e.preventDefault(); setFehler('');
    try {
      const r = await api.post(`/auth/${modus}`, form);
      onLogin(r.data.token);
    } catch(e) { setFehler(e.response?.data?.error || 'Fehler'); }
  }

  const inp = { width: '100%', padding: '12px 14px', borderRadius: '10px', border: '1px solid #e2e8f0', fontSize: '15px', boxSizing: 'border-box', marginBottom: '12px' };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ background: 'white', borderRadius: '20px', padding: '32px', width: '100%', maxWidth: '380px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ fontSize: '48px' }}>🛒</div>
          <h1 style={{ margin: '8px 0 4px', fontSize: '22px', color: '#1e293b' }}>Einkauf & Vorrat</h1>
          <p style={{ color: '#64748b', fontSize: '13px', margin: 0 }}>{modus === 'login' ? 'Anmelden' : 'Registrieren'}</p>
        </div>
        {fehler && <div style={{ background: '#fee2e2', color: '#dc2626', padding: '10px 14px', borderRadius: '8px', marginBottom: '12px', fontSize: '14px' }}>{fehler}</div>}
        <form onSubmit={submit}>
          {modus === 'register' && <input style={inp} placeholder="Name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} />}
          <input style={inp} type="email" placeholder="E-Mail" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required />
          <input style={inp} type="password" placeholder="Passwort" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
          <button type="submit" style={{ width: '100%', padding: '14px', background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', color: 'white', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '700', cursor: 'pointer' }}>
            {modus === 'login' ? '🔑 Anmelden' : '📝 Registrieren'}
          </button>
        </form>
        <button onClick={() => setModus(modus === 'login' ? 'register' : 'login')}
          style={{ width: '100%', marginTop: '12px', padding: '10px', background: 'none', border: 'none', color: '#6366f1', cursor: 'pointer', fontSize: '13px' }}>
          {modus === 'login' ? 'Noch kein Konto? Registrieren' : 'Bereits registriert? Anmelden'}
        </button>
      </div>
    </div>
  );
}
